<template>
  <svg width="31" height="35" viewBox="0 0 31 35" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M13.6623 6.45835C14.5156 5.60508 18.216 5.5476 23.6799 5.54824C24.5914 5.54743 25.502 6.45835 25.5021 7.36902C25.502 12.8336 25.4445 16.534 24.5913 17.3873C23.6805 18.298 12.2953 29.6832 11.8399 30.1386C11.3846 30.594 10.4738 30.594 10.0182 30.1388C9.56262 29.6836 1.36653 21.4863 0.910976 21.0311C0.455416 20.576 0.455624 19.665 0.910998 19.2097C1.36637 18.7543 12.6943 7.42634 13.6623 6.45835Z"
      fill="#00CAAA"
    />
    <circle
      cx="19.1268"
      cy="11.9228"
      r="2.57598"
      transform="rotate(45 19.1268 11.9228)"
      fill="#021B27"
    />
    <path
      d="M14.5731 16.4766L9.10859 21.941"
      stroke="#021B27"
      stroke-width="2"
      stroke-linecap="round"
    />
    <path
      d="M19.2736 23.9816C19.2736 23.9816 19.0982 24.3833 18.5212 24.9603C18.4153 25.0662 18.3153 25.1586 18.2226 25.2388C18.8107 25.8269 22.5804 29.5966 23.2464 30.2626C23.077 30.432 22.9266 30.5196 22.9266 30.5196C22.9266 30.5196 18.5223 26.1153 17.9007 25.4936C17.6768 25.6537 17.5433 25.7119 17.5433 25.7119L23.2105 31.3791C23.2105 31.3791 23.599 31.1897 24.1762 30.6145C24.7535 30.0393 24.9409 29.6488 24.9409 29.6488L19.2736 23.9816Z"
      fill="#00CAAA"
    />
    <path
      d="M18.2713 24.7103C20.6964 22.2853 20.6964 18.3534 18.2713 15.9283C15.8462 13.5033 11.9144 13.5033 9.48933 15.9283C7.06424 18.3534 7.06424 22.2853 9.48933 24.7103C11.9144 27.1354 15.8462 27.1354 18.2713 24.7103Z"
      fill="#00CAAA"
      stroke="#021B27"
    />
    <path
      d="M17.3407 16.8585C19.2519 18.7698 19.2519 21.8686 17.3407 23.7799C15.4294 25.6912 12.3306 25.6912 10.4193 23.7799C8.50806 21.8686 8.50806 18.7698 10.4193 16.8585C12.3306 14.9473 15.4294 14.9473 17.3407 16.8585Z"
      fill="#021B27"
    />
    <path
      d="M16.4442 17.1144C16.8713 17.5417 16.6582 17.7549 16.0171 17.5414C14.0942 16.9009 13.667 16.9009 11.7445 17.5414C11.1034 17.7555 10.8902 17.5414 11.3172 17.1145C12.733 15.6987 15.0284 15.6986 16.4442 17.1144Z"
      fill="#00CAAA"
    />
  </svg>
</template>
